import React from 'react'
import { CSelect } from '@coreui/react'
import PropTypes from 'prop-types'

function GenericDropdown({
  label,
  onChange,
  innerRef,
  options,
  selected,
  name,
  includeEmptyOption = false,
  disabled = false,
}) {
  return (
    <>
      <label className="text-xs text-gray-500 mt-2" htmlFor="wallet">
        {label}
      </label>
      <CSelect
        id={name || 'Wallet'}
        name={name || 'Wallet'}
        innerRef={typeof innerRef === 'function' ? innerRef() : null}
        value={selected}
        onChange={onChange}
        className="player-c"
        disabled={disabled}
      >
        {includeEmptyOption && <option value="">Select an option</option>}
        {options?.map(({ value, label: _label }) => (
          <option key={value} value={value}>
            {_label}
          </option>
        ))}
      </CSelect>
    </>
  )
}

GenericDropdown.propTypes = {
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  selected: PropTypes.any,
  name: PropTypes.string,
  includeEmptyOption: PropTypes.bool,
  disabled: PropTypes.bool,
}

GenericDropdown.defaultProps = {
  innerRef: { current: null },
  label: '',
  onChange: () => null,
  options: [],
  selected: false,
  name: '',
  includeEmptyOption: false,
  disabled: false,
}

export default GenericDropdown
